import { h } from 'preact';

const Rail = (props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" role="img" {...props}>
			<path
				class="st0" d="M5.046,13.6l1.477-1.4h2.954l1.477,1.4H5.046z M6.523,9.4c0,0.386-0.331,0.7-0.738,0.7
			c-0.408,0-0.738-0.314-0.738-0.7s0.331-0.7,0.738-0.7C6.192,8.7,6.523,9.014,6.523,9.4z M4.677,7.3V2.4h6.646v4.9H4.677z
			M10.215,10.1c-0.408,0-0.738-0.314-0.738-0.7s0.331-0.7,0.738-0.7s0.738,0.314,0.738,0.7S10.623,10.1,10.215,10.1z M10.954,12.2
			L10.954,12.2c0.816,0,1.477-0.627,1.477-1.4V1.7c0-0.386-0.331-0.7-0.738-0.7H4.308C3.9,1,3.569,1.314,3.569,1.7v9.1
			c0,0.773,0.661,1.4,1.477,1.4L2.092,15h1.477l0.738-0.7h7.385l0.738,0.7h1.477L10.954,12.2z" 
			/>
		</svg>
	);
};

export default Rail;
